import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Link } from "react-router-dom";
import "./FAQ.css";
import Loading from "../../Components/Loading/Loading";

function FAQ() {
  const [FAQs, setFAQs] = useState();
  const [loading, setLoading] = useState(true);
  const isFetched = useRef(false); // ✅ Prevents duplicate API call
  useEffect(() => {
    if (!isFetched.current) {
      getFAQs();
      isFetched.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  const getFAQs = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/FAQs"
      );

      if (response.data) {
        setFAQs(response.data);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  if (loading) return <Loading />;
  return (
    <div className="faqfront-container container">
      <div className="faq-title-section">
        <div className="faq-first-part">
          <h1>ANY QUESTIONS?</h1>
          <h2>WE GOT YOU</h2>
        </div>
        <div className="faq-second-part">
          <h4>
            <Link to="/contact">
              SOMETHING
              <br />
              ELSE?
            </Link>
          </h4>
          <Link className="reachoutlink" to="/contact">
            Reach Out!
          </Link>
        </div>
      </div>
      <Accordion className="mt-5 accordionfaq-container">
        {FAQs &&
          FAQs.map((faq, index) => (
            <AccordionTab
              key={index}
              headerTemplate={() => (
                <div className="faq-header-custom">
                  <span>{faq.question}</span>
                  <img src="/images/whiteplus.svg" width={30} />
                </div>
              )}
            >
              <div
                className="faq-answer"
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            </AccordionTab>
          ))}
      </Accordion>
    </div>
  );
}

export default FAQ;
